export default function getIframeData() {
  return {
    inIframe: window.self !== window.top,
    referrer: document.referrer,
  };
}
